const mapBetterAuthSession = ({ data, error, isPending }) => {
    if (isPending) {
        return {
            user: null,
            isAuthenticated: false,
            status: 'loading',
        };
    }

    if (error) {
        return {
            user: null,
            isAuthenticated: false,
            status: 'unavailable',
        };
    }

    const user = data?.user;
    if (!user) {
        return {
            user: null,
            isAuthenticated: false,
            status: 'unauthenticated',
        };
    }

    if (typeof user.id !== 'string' || user.id.length === 0) {
        return {
            user: null,
            isAuthenticated: false,
            status: 'unavailable',
        };
    }

    return {
        user: {
            id: user.id,
            ...(typeof user.name === 'string' ? { name: user.name } : {}),
            ...(typeof user.email === 'string' ? { email: user.email } : {}),
        },
        isAuthenticated: true,
        status: 'authenticated',
    };
};

module.exports = mapBetterAuthSession;
